import { Badge, Box, Button, Checkbox, Divider, Flex, FormControl, FormLabel, Grid, GridItem, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Spinner, Text, Textarea, Tooltip, VStack, Radio, RadioGroup, Stack, } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CustomTable, CustomToast, Dropdown, FormInput } from "../../../../components";
import { Column } from "../../../../components/customTable/CustomTable";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFetch } from "../../../../hooks/useFetch";
import { showDate, showDateTime, showTime } from "../../../../utilities/helper";
import * as yup from "yup";
import { EditIcon } from "@chakra-ui/icons";
import { MultiSelectMenu } from "../../../../components/MultiSelectMenu/MultiSelectMenu";
import { refreshHistory } from "../../../../components/History/modal";
import MyDiv from "./followupForm.style";

interface Props {
    leadId: number;
    viewType?: "table" | "card";
    onFollowUpSaved?: (leadId: number) => void;
}
interface IFollowUp {
    id: number;
    leadId: number;
    nextFollowupDate: string;
    followTime: string;
    description: string;
    createdAt: string;
    createdBy: string;
    createdByName?: string;
    remarks?: string;
    isCompleted: boolean;
    followUp_Status?: string;
    messageTypes: { id: number; name: string }[];
    messageTypeName: string;
}
interface IFollowUpForm {
    nextFollowupDate: string;
    followTime: string;
    description: string;
    // messageType?: number[];
    remarks?: string;
    status: string;
}

const defaultValues: IFollowUpForm = {
    nextFollowupDate: "",
    followTime: "",
    description: "",
    // messageType: [],
    remarks: "",
    status: "",
};

export enum MessageType {
    Email = 1,
    SMS = 2,
    Whatsapp = 3,
    Call = 4,
}


const messageTypeOptions = [
    { id: MessageType.Email, name: "Email" },
    { id: MessageType.SMS, name: "SMS" },
    { id: MessageType.Whatsapp, name: "Whatsapp" },
    { id: MessageType.Call, name: "Call" },
];
const schema = yup.object({
    nextFollowupDate: yup.string().required("Reminder date is required"),
    followTime: yup.string().required("Reminder time is required"),
    remarks: yup.string().optional(),
    // description: yup.string().required("Description is required").test("not-empty", "Description cannot be empty", (value) => {
    //     if (!value) return false;
    //     const plainText = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, "").trim()
    //     return plainText.length > 0;
    // }
    // ),
});

const FollowUpFormTab = ({ leadId, viewType = "table", onFollowUpSaved, }: Props) => {
    const [showForm, setShowForm] = useState(false);
    const [followUps, setFollowUps] = useState<IFollowUp[]>([]);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [editId, setEditId] = useState<number | null>(null);
    const [selectedMessageTypes, setSelectedMessageTypes] = useState<number[]>([]);
    const [followUpFilter, setFollowUpFilter] = useState("all");
    const [statusFilter, setStatusFilter] = useState("all");
    const [filterLoading, setFilterLoading] = useState(false);
    const today = new Date().toISOString().split("T")[0];
    const [showRemarks, setShowRemarks] = useState(false);
    const [isCancelledRecord, setIsCancelledRecord] = useState(false);

    const [includeSignature, setIncludeSignature] = useState(false);
    const [signatureType, setSignatureType] = useState<"Short" | "Full">("Short");
    const [includeDisclaimer, setIncludeDisclaimer] = useState(false);

    const [userSignature, setUserSignature] = useState<{ shortSignature: string; fullSignature: string } | null>(null);
    const [websiteDisclaimer, setWebsiteDisclaimer] = useState<string>("");
    const [loadingSignature, setLoadingSignature] = useState(false);
    const [loadingDisclaimer, setLoadingDisclaimer] = useState(false);

    useEffect(() => {
        const fetchSignature = async () => {
            if (includeSignature && !userSignature && !loadingSignature) {
                setLoadingSignature(true);
                try {
                    const res = await fetchApi<{ shortSignature: string; fullSignature: string }>("UserSignature", "GET");
                    if (res) {
                        setUserSignature({
                            shortSignature: res.shortSignature || "",
                            fullSignature: res.fullSignature || "",
                        });
                    }
                } catch (error) {
                    console.error("Error fetching signature:", error);
                } finally {
                    setLoadingSignature(false);
                }
            }
        };
        fetchSignature();
    }, [includeSignature, userSignature, loadingSignature]);

    useEffect(() => {
        const fetchDisclaimer = async () => {
            if (includeDisclaimer && !websiteDisclaimer && !loadingDisclaimer) {
                setLoadingDisclaimer(true);
                try {
                    const res = await fetchApi<{ disclaimer: string }>("WebsiteSetting", "GET");
                    if (res) {
                        setWebsiteDisclaimer(res.disclaimer || "");
                    }
                } catch (error) {
                    console.error("Error fetching disclaimer:", error);
                } finally {
                    setLoadingDisclaimer(false);
                }
            }
        };
        fetchDisclaimer();
    }, [includeDisclaimer, websiteDisclaimer, loadingDisclaimer]);

    const { control, handleSubmit, reset, watch, register, formState: { errors },
    } = useForm<IFollowUpForm>({
        resolver: yupResolver(schema) as any,
        defaultValues,
    });
    const isCancelled = watch("status") === "Cancelled";

    const meetingFilters = [
        { id: "upcoming", name: "Upcoming" },
        { id: "all", name: "All" },
        { id: "previous", name: "Previous" }
    ];

    const statusFilters = [
        { id: "all", name: "All" },
        { id: "pending", name: "pending" },
        { id: "cancelled", name: "cancelled" },
        { id: "done", name: "Done" },

    ];

    const loadFollowUps = async () => {
        setFilterLoading(true);
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const res = await fetchApi(`LeadRequirement/LeadFollowUp?leadId=${leadId}&filter=${followUpFilter}&status=${statusFilter}&timeZone=${encodeURIComponent(timezone)}`, "GET");
        if (Array.isArray(res?.data)) {
            setFilterLoading(false);
            setFollowUps(res.data);
        } else {
            setFollowUps([]);
        }
    };

    useEffect(() => {
        if (leadId) {
            loadFollowUps();
        }
    }, [leadId, followUpFilter, statusFilter]);

    // useEffect(() => {
    //     if (leadId) {
    //         loadFollowUps();
    //     }
    // }, [leadId]);



    const onSubmit = async (data: IFollowUpForm) => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (selectedMessageTypes.length === 0) {
            addToast({
                message: "Please select at least one message type", status: "warning",
            });
            return;
        }
        // const selectedDateTime = new Date(`${data.nextFollowupDate}T${data.followTime}:00`
        // );

        // if (selectedDateTime <= new Date()) {
        //     addToast({
        //         message: "Reminder time must be greater than current time.",
        //         status: "warning",
        //     });
        //     return;
        // }

        if (!editId) {
            const selectedDateTime = new Date(
                `${data.nextFollowupDate}T${data.followTime}:00`
            );

            if (selectedDateTime <= new Date()) {
                addToast({
                    message: "Reminder time must be greater than current time.",
                    status: "warning",
                });
                return;
            }
        }

        const followTimeUtc = data.followTime && data.nextFollowupDate ? new Date(`${data.nextFollowupDate}T${data.followTime}:00`).toISOString() : null;
        const payload = {
            leadId,
            nextFollowupDate: data.nextFollowupDate,
            followTime: followTimeUtc,
            description: data.description,
            messageType: selectedMessageTypes,
            isCompleted: editId ? showRemarks : false,
            followUp_Status: data.status,
            remarks: data.remarks,
            timezone: timezone,
            IncludeSignature: includeSignature,
            IncludeDisclaimer: includeDisclaimer,
            SignatureType: signatureType,
        };

        const res = editId ? await fetchApi(`LeadRequirement/LeadFollowUp/${editId}`, "PUT", payload, null, "Reminder Updated Successfully")
            : await fetchApi("LeadRequirement/LeadFollowUp", "POST", payload, null, "Reminder Added Successfully");
        if (res) {
            setShowForm(false);
            setEditId(null);
            setIncludeSignature(false);
            setIncludeDisclaimer(false);
            setSignatureType("Short");
            reset(defaultValues);
            loadFollowUps();
            onFollowUpSaved?.(leadId);
            refreshHistory("Lead", leadId);
        }
    };
    const stripHtml = (html: string) => {
        const doc = new DOMParser().parseFromString(html || "", "text/html");
        return doc.body.textContent || "";
    };

    const closeModal = () => {
        setShowForm(false);
        setEditId(null);
        setShowRemarks(false);
        setSelectedMessageTypes([]);
        setIncludeSignature(false);
        setIncludeDisclaimer(false);
        setSignatureType("Short");
        reset(defaultValues);
    };

    const parseFollowUpDateTime = (followTime: string) => {
        return new Date(followTime.endsWith("Z") ? followTime : `${followTime}Z`);
    };

    const isPastFollowUp = (row: IFollowUp) => {
        if (!row.followTime) return false;

        const followUpDateTime = parseFollowUpDateTime(row.followTime);

        return followUpDateTime.getTime() < Date.now();
    };

    const isFollowUpApproaching = (row: IFollowUp) => {
        if (
            row.followUp_Status === "Cancelled" ||
            row.followUp_Status === "Done" ||
            row.isCompleted ||
            !row.followTime
        ) {
            return false;
        }

        const now = new Date();
        const followUpTime = parseFollowUpDateTime(row.followTime);

        const diffMinutes =
            (followUpTime.getTime() - now.getTime()) / (1000 * 60);

        return diffMinutes <= 15 && diffMinutes >= 0;
    };

    const isFollowUpToday = (row: IFollowUp) => {
        if (
            row.followUp_Status === "Cancelled" ||
            row.followUp_Status === "Done" ||
            row.isCompleted ||
            !row.followTime ||
            isPastFollowUp(row) ||
            isFollowUpApproaching(row)
        ) {
            return false;
        }

        const today = new Date();
        const followUpTime = parseFollowUpDateTime(row.followTime);

        return (
            followUpTime.getFullYear() === today.getFullYear() &&
            followUpTime.getMonth() === today.getMonth() &&
            followUpTime.getDate() === today.getDate()
        );
    };

    return (
        <MyDiv>
            <Box>
                <Flex justify="space-between" align="center" mb={4}>
                    <Text className="font-poppins text_lg text_semibold">
                        Reminders
                    </Text>
                    {/* <Button size="sm" className="font-poppins text_medium text_sm" bg="#4048D6" color="white" _hover={{ bg: "#353CC4" }} onClick={() => setShowForm(true)}>
                    New Reminder
                </Button> */}
                    <Flex gap={3} align="center">

                        <Select
                            value={statusFilter}
                            onChange={(e: any) => setStatusFilter(e.target.value)}
                            size="sm"
                            w="150px"
                        >
                            {statusFilters.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </Select>

                        <Select
                            value={followUpFilter}
                            onChange={(e: any) => setFollowUpFilter(e.target.value)}
                            size="sm"
                            w="150px"
                        >
                            {meetingFilters.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </Select>

                        <Button
                            size="sm"
                            className="font-poppins text_medium text_sm"
                            bg="#4048D6"
                            color="white"
                            _hover={{ bg: "#353CC4" }}
                            onClick={() => {
                                setEditId(null);
                                setIsCancelledRecord(false);
                                setShowRemarks(false);
                                setSelectedMessageTypes([]);
                                reset(defaultValues);
                                setShowForm(true);
                            }}
                        >
                            New Reminder
                        </Button>
                    </Flex>
                </Flex>
                {viewType === "table" ? (
                    <Box>
                        {filterLoading ? (
                            <Flex justify="center" py={10}>
                                <Spinner thickness="2px" speed="0.65s" color="#0052CC" size="lg" />
                            </Flex>
                        ) : (
                            <CustomTable value={followUps} showEmptyMessage={false} pagination={false}
                                rowClassName={(row) => {
                                    if (row.followUp_Status === "Cancelled" || isPastFollowUp(row)) {
                                        return "expired-row";
                                    }

                                    if (isFollowUpApproaching(row)) {
                                        return "blink-approaching";
                                    }

                                    if (isFollowUpToday(row)) {
                                        return "blink-today";
                                    }

                                    return "";
                                }}
                                rowStyle={(row: IFollowUp) => {
                                    if (row.followUp_Status === "Cancelled" || isPastFollowUp(row)) {
                                        return {
                                            backgroundColor: "#FEE2E2",
                                            color: "#DC2626",
                                        };
                                    }
                                    if (isFollowUpApproaching(row) || isFollowUpToday(row)) {
                                        return {};
                                    }
                                    return {
                                        backgroundColor: "#FFFFFF",
                                        color: "#1D2939",
                                    };
                                }}
                            >
                                <Column header="S.No" body={(_, index) => index + 1} />
                                <Column header="Reminder Date" body={(row: IFollowUp) => showDate(row.followTime)} />
                                <Column header="Reminder Time" body={(row: IFollowUp) => showTime(row.followTime)} />

                                <Column header="Description" body={(row: IFollowUp) => {
                                    const plainText = stripHtml(row.description);
                                    return (
                                        <Tooltip label={plainText} placement="top" hasArrow maxW="500px" whiteSpace="pre-wrap">
                                            <Text maxW="250px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" cursor="pointer" >
                                                {plainText}
                                            </Text>
                                        </Tooltip>
                                    );
                                }}
                                />
                                <Column header="Created At" body={(row: any) => showDateTime(row.createdAt)} />

                                <Column header="Created By" field="createdByName" />
                                <Column header="Reminder Type" field="messageTypeName" />
                                {followUps.some((x) => x.followUp_Status) && (
                                    <Column header="Status" field="followUp_Status" />
                                )}

                                <Column header="Action" body={(row: IFollowUp) => (
                                    <EditIcon cursor="pointer" color="#4048D6" onClick={() => {
                                        setEditId(row.id);
                                        setIsCancelledRecord(
                                            row.followUp_Status === "Cancelled"
                                        );
                                        reset({
                                            nextFollowupDate: row.nextFollowupDate?.split("T")[0],
                                            followTime: row.followTime ? new Date(row.followTime.endsWith("Z") ? row.followTime
                                                : `${row.followTime}Z`).toLocaleTimeString("en-GB", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false,
                                                })
                                                : "",
                                            description: row.description,
                                            remarks: row.remarks || "",
                                            status: row.followUp_Status || "",
                                        });
                                        setSelectedMessageTypes(
                                            row.messageTypes?.map((x) => x.id) || []
                                        );
                                        setShowRemarks(row.isCompleted);
                                        setShowForm(true);
                                    }}
                                    >
                                        Edit
                                    </EditIcon>
                                )}
                                />
                            </CustomTable>
                        )}
                    </Box>
                ) : (
                    <>
                        {filterLoading ? (
                            <Flex justify="center" align="center" height="300px" >
                                <Spinner
                                    thickness="2px"
                                    speed="0.65s"
                                    color="#0052CC"
                                    size="lg"
                                />
                            </Flex>
                        ) : followUps.length === 0 ? (
                            <Flex direction="column" justify="center" align="center" height="300px" >
                                <Text color="gray.500">
                                    No Reminders Found
                                </Text>
                            </Flex>
                        ) : (
                            <Grid gap={4}>
                                {followUps.map((followUp) => (
                                    <Box
                                        key={followUp.id}
                                        bg="white"
                                        border="1px solid #E4E7EC"
                                        borderRadius="16px"
                                        p={5}
                                    >
                                        <Flex justify="space-between" align="center" mb={4}>
                                            <Box>
                                                <Text fontSize="lg" fontWeight="600">
                                                    {followUp.messageTypeName}
                                                </Text>
                                            </Box>

                                            <Flex align="center" gap={3}>
                                                <Text
                                                    px={3}
                                                    py={1}
                                                    borderRadius="full"
                                                    bg={followUp.followUp_Status === "Cancelled" ? "#FEE2E2" : "#ECFDF3"}
                                                    color={followUp.followUp_Status === "Cancelled" ? "#DC2626" : "#027A48"}
                                                    fontSize="12px"
                                                    fontWeight="600"
                                                >
                                                    {followUp.followUp_Status || "Pending"}
                                                </Text>

                                                <EditIcon
                                                    cursor="pointer"
                                                    color="#4048D6"
                                                    onClick={() => {
                                                        setEditId(followUp.id);
                                                        setIsCancelledRecord(followUp.followUp_Status === "Cancelled");

                                                        reset({
                                                            nextFollowupDate: followUp.nextFollowupDate?.split("T")[0],

                                                            followTime: followUp.followTime
                                                                ? new Date(
                                                                    followUp.followTime.endsWith("Z") ? followUp.followTime : `${followUp.followTime}Z`
                                                                ).toLocaleTimeString("en-GB", {
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                    hour12: false,
                                                                })
                                                                : "",

                                                            description: followUp.description,
                                                            remarks: followUp.remarks || "",
                                                            status:
                                                                followUp.followUp_Status || "",
                                                        });

                                                        setSelectedMessageTypes(
                                                            followUp.messageTypes?.map(
                                                                (x) => x.id
                                                            ) || []
                                                        );

                                                        setShowRemarks(
                                                            followUp.isCompleted
                                                        );

                                                        setShowForm(true);
                                                    }}
                                                />
                                            </Flex>
                                        </Flex>

                                        <Grid templateColumns="repeat(4,1fr)" gap={4} mb={4} >
                                            <Box>
                                                <Text color="gray.500" fontSize="sm">
                                                    Date
                                                </Text>
                                                <Text>
                                                    {showDate(followUp.nextFollowupDate)}
                                                </Text>
                                            </Box>

                                            <Box>
                                                <Text color="gray.500" fontSize="sm">
                                                    Time
                                                </Text>
                                                <Text>
                                                    {showTime(followUp.followTime)}
                                                </Text>
                                            </Box>

                                            <Box>
                                                <Text color="gray.500" fontSize="sm">
                                                    Created By
                                                </Text>
                                                <Text>
                                                    {followUp.createdByName || followUp.createdBy}
                                                </Text>
                                            </Box>

                                            <Box>
                                                <Text color="gray.500" fontSize="sm">
                                                    Created At
                                                </Text>
                                                <Text>
                                                    {showDateTime(followUp.createdAt)}
                                                </Text>
                                            </Box>
                                        </Grid>

                                        <Box borderTop="1px solid #E4E7EC" pt={3}>
                                            <Text color="gray.500" fontSize="sm" mb={1}>
                                                Description
                                            </Text>

                                            <Text fontSize="sm">
                                                {stripHtml(followUp.description)}
                                            </Text>
                                        </Box>
                                    </Box>
                                ))}
                            </Grid>
                        )}
                    </>
                )}

                <Modal isOpen={showForm} onClose={closeModal} size="lg">
                    <ModalOverlay />
                    <form noValidate onSubmit={handleSubmit(onSubmit)}>
                        <ModalContent maxH="500px" overflow="scroll">
                            <ModalHeader>
                                {editId ? "Edit Reminder" : "New Reminder"}
                            </ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                <Flex gap={2} >
                                    <FormInput isRequired name="nextFollowupDate" control={control} label="Reminder Date" type="date" errors={errors} min={today} disable={isCancelledRecord} />
                                    <FormInput isRequired name="followTime" control={control} label="Reminder Time" type="time" errors={errors} disable={isCancelledRecord} />
                                </Flex>
                                <FormControl isRequired mt={2} isDisabled={isCancelledRecord}>
                                    <FormLabel className='font-poppins text_medium text_md '>
                                        Reminder Channel
                                    </FormLabel>

                                    <MultiSelectMenu options={messageTypeOptions} labelKey="name" valueKey="id" selectedValues={selectedMessageTypes} setSelectedValues={setSelectedMessageTypes} placeholder="Select Message Types" isDisabled={isCancelledRecord} />
                                </FormControl>

                                {editId && (
                                    <>

                                        {/* <Box mt={2} className='font-poppins text_medium text_md'  >
                                        <Checkbox isChecked={showRemarks} onChange={(e) => setShowRemarks(e.target.checked)} className='font-poppins text_medium text_md ' isDisabled={isCancelledRecord}>
                                            Completed
                                        </Checkbox>
                                    </Box>
 */}



                                        {showRemarks && (
                                            <GridItem colSpan={2} >
                                                <FormControl isDisabled={isCancelledRecord}>
                                                    <FormLabel className='font-poppins text_medium text_md '> Remarks</FormLabel>
                                                    <Textarea placeholder="Add Remarks" bg={'white'} className=" font_poppins text_regular text_sm"  {...register(`remarks`)} />
                                                </FormControl>
                                            </GridItem>
                                        )}

                                        <FormControl mt={2} mb={2} isDisabled={isCancelledRecord}>
                                            <FormLabel className="font-poppins text_medium text_md">
                                                Status
                                            </FormLabel>

                                            <Select {...register("status")}>
                                                <option value="">Select Status</option>
                                                <option value="Done">Done</option>
                                                <option value="Pending">Pending</option>
                                                <option value="Cancelled">Cancelled</option>
                                            </Select>
                                        </FormControl>
                                    </>
                                )}

                                {/* {editId && (
                                <GridItem colSpan={2}>
                                    <FormControl >
                                        <FormLabel className="font_poppins text_md text_medium"> Remarks</FormLabel>
                                        <Textarea placeholder="Add Remarks" bg={'white'} className=" font_poppins text_regular text_sm"  {...register(`remarks`)} />
                                    </FormControl>
                                </GridItem>
                            )} */}
                                {/* <GridItem colSpan={2} mt={2}>
                                <Text mb={1} fontSize="sm" fontWeight="500" color="gray.600">Description <Text as="span" color="red.500">*</Text></Text>
                                <Controller name="description" control={control} render={({ field }) => (
                                    <SunEditor setContents={field.value} onChange={(content) => { field.onChange(content); }} setOptions={{ minHeight: "200px" }} />
                                )} />
                                {errors.description && (
                                    <Text color="red.500" fontSize="sm" mt={1}>
                                        {errors.description.message}
                                    </Text>
                                )}
                            </GridItem> */}
                                <GridItem colSpan={2}>
                                    <FormControl isInvalid={!!errors.description} isDisabled={isCancelledRecord}>
                                        <FormLabel className='font-poppins text_medium text_md '> Description</FormLabel>
                                        <Textarea placeholder="Add Description" bg={'white'} className=" font_poppins text_regular text_sm"  {...register(`description`)} />
                                        {errors.description && (
                                            <Text color="red.500" fontSize="sm" mt={1}>
                                                {errors.description.message}
                                            </Text>
                                        )}
                                    </FormControl>
                                </GridItem>
                                {/* <GridItem colSpan={2} mt={3}>
                                    <FormControl>
                                        <FormLabel>Email Options</FormLabel>

                                        <Flex direction="column" gap={4}>
                                            <Box>
                                                <Checkbox isChecked={includeSignature}
                                                    onChange={(e) => setIncludeSignature(e.target.checked)}
                                                    isDisabled={isCancelledRecord}
                                                >
                                                    Show Signature
                                                </Checkbox>
                                                {includeSignature && (
                                                    <Box mt={3} pl={6} borderLeft="2px solid" borderColor="blue.100">
                                                        <RadioGroup onChange={(val) => setSignatureType(val as "Short" | "Full")} value={signatureType}>
                                                            <Flex gap={4} mb={2}>
                                                                <Radio value="Short" colorScheme="blue" isDisabled={isCancelledRecord}>Short Signature</Radio>
                                                                <Radio value="Full" colorScheme="blue" isDisabled={isCancelledRecord}>Full Signature</Radio>
                                                            </Flex>
                                                        </RadioGroup>
                                                        {loadingSignature ? (
                                                            <Flex align="center" gap={2} mt={2}>
                                                                <Spinner size="xs" color="#4048D6" />
                                                                <Text fontSize="xs" color="gray.500">Loading signature...</Text>
                                                            </Flex>
                                                        ) : (
                                                            <Box 
                                                                mt={2} 
                                                                p={3} 
                                                                bg="gray.50" 
                                                                borderRadius="md" 
                                                                border="1px solid" 
                                                                borderColor="gray.200" 
                                                                maxH="150px" 
                                                                overflowY="auto"
                                                                fontSize="sm"
                                                            >
                                                                {signatureType === "Short" ? (
                                                                    userSignature?.shortSignature ? (
                                                                        <Box dangerouslySetInnerHTML={{ __html: userSignature.shortSignature }} />
                                                                    ) : (
                                                                        <Text color="gray.400" fontStyle="italic">No short signature configured.</Text>
                                                                    )
                                                                ) : (
                                                                    userSignature?.fullSignature ? (
                                                                        <Box dangerouslySetInnerHTML={{ __html: userSignature.fullSignature }} />
                                                                    ) : (
                                                                        <Text color="gray.400" fontStyle="italic">No full signature configured.</Text>
                                                                    )
                                                                )}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>

                                            <Box>
                                                <Checkbox
                                                    isChecked={includeDisclaimer}
                                                    onChange={(e) => setIncludeDisclaimer(e.target.checked)}
                                                    isDisabled={isCancelledRecord}
                                                >
                                                    Show Disclaimer
                                                </Checkbox>
                                                {includeDisclaimer && (
                                                    <Box mt={3} pl={6} borderLeft="2px solid" borderColor="blue.100">
                                                        {loadingDisclaimer ? (
                                                            <Flex align="center" gap={2}>
                                                                <Spinner size="xs" color="#4048D6" />
                                                                <Text fontSize="xs" color="gray.500">Loading disclaimer...</Text>
                                                            </Flex>
                                                        ) : (
                                                            <Box 
                                                                p={3} 
                                                                bg="gray.50" 
                                                                borderRadius="md" 
                                                                border="1px solid" 
                                                                borderColor="gray.200" 
                                                                maxH="150px" 
                                                                overflowY="auto"
                                                                fontSize="sm"
                                                            >
                                                                {websiteDisclaimer ? (
                                                                    <Box dangerouslySetInnerHTML={{ __html: websiteDisclaimer }} />
                                                                ) : (
                                                                    <Text color="gray.400" fontStyle="italic">No disclaimer configured.</Text>
                                                                )}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>
                                        </Flex>
                                    </FormControl>
                                </GridItem> */}
                            </ModalBody>
                            <ModalFooter>
                                <Button variant="outline" mr={3} onClick={closeModal}>
                                    Cancel
                                </Button>

                                <Button bg="#4048D6" color="white" type="submit" isLoading={loading} isDisabled={isCancelledRecord}>
                                    {editId ? "Update" : "Save"}

                                </Button>
                            </ModalFooter>
                        </ModalContent>
                    </form>
                </Modal>
            </Box >
        </MyDiv>
    );
};

export default FollowUpFormTab;